import { readDeviceProgress, seedDeviceProgress } from "./deviceProgress";
import { plainRecord } from "./progressData";
import { readUserXp } from "./userXpReader";
import { computeXpBreakdown, ProgressSnapshots } from "./xp";
const features = computeXpBreakdown({}).entries.map(entry => entry.feature);
export async function readDeviceXp(identity: string) {
    const records = await Promise.all(features.map(feature => readDeviceProgress(identity, feature)));
    const snapshots: ProgressSnapshots = {};
    records.forEach((row, index) => { if (row.record) (snapshots as Record<string, unknown>)[features[index]] = row.record.data; });
    return { snapshots, records, available: records.some(row => row.record), partial: records.some(row => !row.record), pending: records.some(row => row.pending) };
}
export async function readWorkspaceXp(identity: string, online: boolean, active: () => boolean) {
    const remote = online && active() ? readUserXp(identity).then(rows => ({ rows })).catch(error => ({ error })) : null;
    let local = await readDeviceXp(identity);
    if (online && active()) {
        try {
            const result = await remote;
            if (!result || !("rows" in result)) throw new Error("Cloud progress unavailable");
            const rows = result.rows;
            for (let index = 0; index < features.length && active(); index++) {
                const feature = features[index];
                await seedDeviceProgress(identity, feature, plainRecord(feature, rows[feature]?.data), local.records[index].record?.revision || 0, rows[feature]?.updatedAt);
            }
            local = await readDeviceXp(identity);
            return { ...local, source: local.pending ? "device" as const : "cloud" as const };
        } catch { local = await readDeviceXp(identity); }
    }
    if (!local.available) throw new Error("Open this account online to prepare its level");
    return { ...local, source: "device" as const };
}
